import { types } from "mobx-state-tree";
import { IInput } from "./utils/common-interface";

export enum pageSizeSet {
  small = "70%",
  regular = "100%",
  big = "130%",
}

export const AppModel = types
  .model("AppModel", {
    pageSize: types.optional(types.string, pageSizeSet.regular),
    expandedSidebar: types.optional(types.boolean, true),
  })
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setPageSize: (pageSize: pageSizeSet) => {
      self.pageSize = pageSize;
      document.body.style.zoom = self.pageSize;
    },
  }));
export type IAppModel = typeof AppModel.Type;
export default AppModel.create({});
